import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Add this

const ContactForm = () => {
  const navigate = useNavigate();
  const [csrfToken, setCsrfToken] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    service: "",
    message: "",
    size: "",
    company: "",
    ip: "",
  });
  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch user IP when component mounts
  const [ip, setIp] = useState(null);
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIp(data.ip))
      .catch((err) => console.error("Failed to fetch IP", err));
  }, []);
  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/contact-form`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          service: formData.service,
          message: formData.message,
          size: formData.size,
          company: formData.company,
          ip: ip,
        }),
      });
      console.log("Response:", response.message);
      // alert("Form submitted successfully!");
      navigate("/thank-you");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form.");
    }
  };
  return (
    <section className="contact-section" id="enquiry">
      <div className="container">

        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="contact-form">
              <h2>Tell us your needs</h2>
              <form
                className="row"
                onSubmit={handleSubmit}
              >
                <div className="col-md-6 required">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    required
                    placeholder="Name"
                    value={formData.name} onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="mobile"
                    className="form-control"
                    name="mobile"
                    id="mobile"
                    required
                    placeholder="Mobile"
                    value={formData.mobile} onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    required
                    placeholder="Email"
                    value={formData.email} onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    name="company"
                    id="company"
                    required
                    placeholder="Company"
                    value={formData.company} onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                <input
                    type="number"
                    className="form-control"
                    name="size"
                    id="size"
                    required
                    placeholder="Desk/Seat Required"
                    value={formData.size} onChange={handleChange}
                    min="1"
                  />
                </div>
                <div className="col-md-6">
                  <select className="form-control" name="service" placeholder="Select Service" value={formData.service} onChange={handleChange}>
                    <option className="custom-option" >Select Service</option>
                    <option className="custom-option" value="Managed Offices">Managed Offices</option>
                    <option className="custom-option" value="Private Cabins">Private Cabins</option>
                    <option className="custom-option" value="Dedicated Desk">Dedicated Desk</option>
                    <option className="custom-option" value="Conference Room">Conference Room</option>
                    <option className="custom-option" value="Meeting Hall">Meeting Hall</option>
                    <option className="custom-option" value="Virtual Office">Virtual Office</option>
                    <option className="custom-option" value="Other">Other</option>
                  </select>
                </div>
                <div className="col-md-12">
                  <textarea
                    className="form-control"
                    name="message"
                    id="message"
                    required
                    placeholder="Message"
                    value={formData.message} onChange={handleChange}
                  />
                </div>
                <input type="hidden" name="ip" value={ip } />
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    formTarget="_blank"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};
export default ContactForm;